import React from "react";
import Test_01 from '../../../assets/images/testimonial/testimonial-detail-qute.png';
import Test_02 from '../../../assets/images/testimonial/testimonial-detail-1.png';
import Test_03 from '../../../assets/images/testimonial/testimonial-detail-2.png';
import Test_04 from '../../../assets/images/testimonial/testimonial-detail-3.png';
import Test_05 from '../../../assets/images/testimonial/testimonial-detail-4.png';
import Test_06 from '../../../assets/images/testimonial/testimonial-detail-5.png';
import Test_07 from '../../../assets/images/testimonial/testimonial-detail-6.png';



const TestimonialsOne = () => {
    return (
        <div className="testimonial-page-section">
            <div className="container">
                <div className="row gutter-x-15 gutter-y-30">
                    <div className="col-lg-6">
                        <div
                            className="testimonial-box animate fadeInUp wow animated"
                            data-wow-duration="1500ms"
                            data-wow-delay="200ms"
                        >
                            <span className="testimonial-icon">
                                <img
                                    src={Test_01}
                                    alt="icon"
                                />
                            </span>
                            <div className="testimonial-heading">
                                <img
                                    src={Test_02}
                                    alt="testimonial-image"
                                />
                                <div className="testimonial-title">
                                    <h4>John Mathew</h4>
                                    <p>Designer</p>
                                </div>
                            </div>
                            <div className="testimonial-body">
                                <p>
                                    Consulting services give access to more experienced levels of
                                    expertise than would be feasible to retain in house. Consultants
                                    provide expertise to clients.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div
                            className="testimonial-box animate fadeInUp wow animated"
                            data-wow-duration="1500ms"
                            data-wow-delay="400ms"
                        >
                            <span className="testimonial-icon">
                                <img
                                    src={Test_01}
                                    alt="icon"
                                />
                            </span>
                            <div className="testimonial-heading">
                                <img
                                    src={Test_03}
                                    alt="testimonial-image"
                                />
                                <div className="testimonial-title">
                                    <h4>Jessica</h4>
                                    <p>Developer</p>
                                </div>
                            </div>
                            <div className="testimonial-body">
                                <p>
                                    Results driven marketing campaigns are deployed to achieve
                                    client’s objectives. A strong return on investment is the main
                                    goal, achieved by individual marketing.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div
                            className="testimonial-box animate fadeInUp wow animated"
                            data-wow-duration="1500ms"
                            data-wow-delay="600ms"
                        >
                            <span className="testimonial-icon">
                                <img
                                    src={Test_01}
                                    alt="icon"
                                />
                            </span>
                            <div className="testimonial-heading">
                                <img
                                    src={Test_04}
                                    alt="testimonial-image"
                                />
                                <div className="testimonial-title">
                                    <h4>Emma Rossie</h4>
                                    <p>Customer</p>
                                </div>
                            </div>
                            <div className="testimonial-body">
                                <p>
                                    Quality and experienced design &amp; development services to
                                    start, manage, and grow Internet websites and infrastructures.
                                    Customized design services.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div
                            className="testimonial-box animate fadeInUp wow animated"
                            data-wow-duration="1500ms"
                            data-wow-delay="800ms"
                        >
                            <span className="testimonial-icon">
                                <img
                                    src={Test_01}
                                    alt="icon"
                                />
                            </span>
                            <div className="testimonial-heading">
                                <img
                                    src={Test_05}
                                    alt="testimonial-image"
                                />
                                <div className="testimonial-title">
                                    <h4>Williamson</h4>
                                    <p>Marketer</p>
                                </div>
                            </div>
                            <div className="testimonial-body">
                                <p>
                                    Consulting services give access to more experienced levels of
                                    expertise than would be feasible to retain in house. Consultants
                                    provide expertise to clients.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div
                            className="testimonial-box animate fadeInUp wow animated"
                            data-wow-duration="1500ms"
                            data-wow-delay="1000ms"
                        >
                            <span className="testimonial-icon">
                                <img
                                    src={Test_01}
                                    alt="icon"
                                />
                            </span>
                            <div className="testimonial-heading">
                                <img
                                    src={Test_06}
                                    alt="testimonial-image"
                                />
                                <div className="testimonial-title">
                                    <h4>Mathieu Haiden</h4>
                                    <p>Customer</p>
                                </div>
                            </div>
                            <div className="testimonial-body">
                                <p>
                                    Results driven marketing campaigns are deployed to achieve
                                    client’s objectives. A strong return on investment is the main
                                    goal, achieved by individual marketing.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div
                            className="testimonial-box animate fadeInUp wow animated"
                            data-wow-duration="1500ms"
                            data-wow-delay="1200ms"
                        >
                            <span className="testimonial-icon">
                                <img
                                    src={Test_01}
                                    alt="icon"
                                />
                            </span>
                            <div className="testimonial-heading">
                                <img
                                    src={Test_07}
                                    alt="testimonial-image"
                                />
                                <div className="testimonial-title">
                                    <h4>Sara Jackson</h4>
                                    <p>Designer</p>
                                </div>
                            </div>
                            <div className="testimonial-body">
                                <p>
                                    Quality and experienced design &amp; development services to
                                    start, manage, and grow Internet websites and infrastructures.
                                    Customized design services.
                                </p>
                                <p></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
export default TestimonialsOne;